enum StatoProcessoFirmaDigitale {
    NonEsiste = 0,
    InCorso = 1,
    Annullato = 2,
    Completato = 3,
}

export default StatoProcessoFirmaDigitale;
